module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-shadow-9.f263d886.png";